module.exports = __webpack_public_path__ + "static/media/Aeonik-Bold.22877912.woff2";